export default __webpack_public_path__ + "static/media/hero-memories@2x.c02ef88a.png";